import YaySmallIcon from './component.jsx'
export default YaySmallIcon
